import type {RootState} from 'services/store'

export const modalsSelector = (state: RootState) => state.modals
